/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < codebhendi, Ravi Ranjan Kumar,  Mylavarapu Sarath Sai, Sanket, Amal Sabu, Ujjwal Singh >

*/

import { client, fetchClient } from "./";
import {
  getUsers,
  saveUserDetail,
  updateUserDetail,
  getUserSettingsFromIdb,
  saveUserSettings,
  updateUserSettingsIdb,
} from "database/offlineDb/indexDb";
import { getAuthTokenFromSessionStorage } from "helpers/common";
import data from "views/UserList/data";
export const userLogin = (data) => (dispatch) => {
  let response = dispatch({
    type: "USER_LOGIN",
    payload: client
      .post("/login", data, {
        withCredentials: true,
        headers: {
          "Content-Type": "Application/json",
          Accept: "*/*",
        },
      })
      .then((res) => {
        // console.log("reponse==>", res.headers);
        return res;
      }),
  });
  return response;
};
// export function userLogin(data) {
//     return dispatch => {
//         dispatch({
//             type: 'USER_LOGIN_PENDING',
//             // payload: response
//         });
//         return fetchClient('/login', {
//             body:JSON.stringify(data),
//             method: 'POST',
//             headers: {
//                 "Content-Type": 'Application/json',
//                 "Accept": "*/*",
//             },
//             credentials:'include',
//         })
//             .then(response => {
//                 if(response!==undefined){
//                     dispatch({
//                         type: 'USER_LOGIN_FULFILLED',
//                         payload: response
//                     });
//                     return response;
//                 }
//             })
//             .catch(error =>{
//                 dispatch({
//                     type: 'USER_LOGIN_REJECTED',
//                     payload: error.message
//                 })
//                 // return error.message
//             }
//             );
//     };
// }
// export const getuserDetail = (user_id, token) => (dispatch) => {
//   let response = dispatch({
//     type: "GET_USER_DETAIL",
//     payload: client.get(`/user/${user_id}`, {
//       headers: {
//         Accept: "*/*",
//         authorization: getAuthTokenFromSessionStorage(),
//       },
//     }),
//     // .then((res) => {

//     // }),
//   });
//   // console.log("response getUserDetail", response);
//   return response;
// };
export const getuserDetailNew =
  (fetchNewDetails = false) =>
  (dispatch) => {
    if (fetchNewDetails) {
      try {
        return client
          .get(`/user`, {
            headers: {
              Accept: "*/*",
              authorization: getAuthTokenFromSessionStorage(),
            },
          })
          .then((backendRes) => {
            const userDetails = {
              ...backendRes.data?.[0],
              ...backendRes?.data?.[1],
            };
            return saveUserDetail(userDetails).then((saveUserToIdbRes) => {
              dispatch({
                type: "GET_USER_DETAIL",
                payload: userDetails,
              });
              return userDetails;
            });
          });
      } catch (error) {
        console.log("userDetails action data fetch error", error);
      }
    } else {
      return getUsers().then((users) => {
        if (users?.length) {
          dispatch({
            type: "GET_USER_DETAIL",
            payload: users?.[0],
          });
          return users?.[0];
        } else {
          return getuserDetailNew(true)(dispatch);
        }
      });
    }
  };

const parseUserSettings = (userSettings) => {
  let settings = {
    inputFileLimit: 2,
    inputFileSize: 10,
    // Reducing the inputFilesBulk to 10 from 100 for bulk upload demo, Author:Sai
    // inputFilesBulk: 100,
    inputFilesBulk: 10,
    cameraType: "NON-MYDRIATIC",
    algorithms: ["Normal-Dr-NonDr-Pipeline-2"],
    imgDimension: "512",
    cameraModel: "",
    cameraVendor: "",
    themeName: "orangeTheme",
    reportLength: 1,
  };
  for (let i = 0; i < userSettings.length; i++) {
    settings[`${userSettings[i].property}`] = userSettings[i].value;
  }
  return settings;
};

const arrayToObject = (array) =>
  array.reduce((obj, item) => {
    obj[
      item.property === "report_length_user" ? "reportLength" : item.property
    ] = item.value;
    return obj;
  }, {});

export const getUserSettings =
  (fetchLatestSettings = false) =>
  async (dispatch) => {
    if (fetchLatestSettings) {
      try {
        return client
          .get(`/setting/user`, {
            headers: {
              Accept: "*/*",
              authorization: getAuthTokenFromSessionStorage(),
            },
          })
          .then((backendRes) => {
            const userSettings = Array.isArray(backendRes?.data)
              ? backendRes.data
              : [];
            const parsedUserSettings = arrayToObject(userSettings);

            saveUserSettings(parsedUserSettings).then((saveUserToIdbRes) => {
              dispatch({
                type: "GET_USER_SETTINGS",
                payload: parsedUserSettings,
              });
              return parsedUserSettings;
            });
          });
      } catch (error) {
        const defaultSettings = parseUserSettings();
        saveUserSettings(defaultSettings).then((saveUserToIdbRes) => {
          dispatch({
            type: "GET_USER_SETTINGS",
            payload: defaultSettings,
          });
          return defaultSettings;
        });
        console.log("userDetails action data fetch error", error);
      }
    } else {
      return getUserSettingsFromIdb().then((userSettings) => {
        if (userSettings?.length) {
          dispatch({
            type: "GET_USER_SETTINGS",
            payload: userSettings?.[0],
          });
          return userSettings?.[0];
        } else {
          return getUserSettings(true)(dispatch);
        }
      });
    }
  };
// export const orgCountsAndBalancesRes = (id, token, orgz_id) => (dispatch) => {
//   let response = dispatch({
//     type: "GET_COUNT_AND_BALANCE",
//     payload: client.get(`/orgCountsAndBalances`, {
//       // withCredentials:true,
//       headers: {
//         Accept: "*/*",
//         authorization: token,
//       },
//     }),
//   });
//   return response;
// };
// export const getUserDetailFromIndexDB = (props) => (dispatch) => {

//   let userDetails = props.userStore?.userProfile?.user_id
//     ? props.userStore?.userProfile
//     : populateUserDetailIfMissing();
//   let response = dispatch({
//     type: "UPDATE_USER_DETAIL",
//     payload: userDetails,
//   });
//   return response;
// };
// store
export function createUserApplicationSettingForm(field, value) {
  return (dispatch) => {
    dispatch({
      type: "CREATE_USER_APP_SETTING_FORM",
      payload: { field, value },
    });
  };
}
const currentRealtimeScope = (scope) => {
  try {
    return typeof scope?.isCurrent !== "function" || scope.isCurrent();
  } catch (error) {
    return false;
  }
};

export const updateOrgCountsAndBalances = (scope = {}) => async (dispatch) => {
  if (!currentRealtimeScope(scope)) return { outcome: "ignored" };
  const orgCountsAndBalancesRes = await client.get(`/orgCountsAndBalances`, {
    headers: {
      Accept: "*/*",
      authorization: getAuthTokenFromSessionStorage(),
    },
  });
  if (!currentRealtimeScope(scope)) return { outcome: "ignored" };
  return dispatch({
    type: "UPDATE_IMAGE_PROCESS_AND_BALANCE_AMOUNT",
    payload: orgCountsAndBalancesRes.data?.orgCountsAndBalances,
  });
};
export const updateProcessCount = (count) => (dispatch) => {
  // console.log("count from action", count);
  return dispatch({
    type: "UPDATE_PROCESS_COUNT",
    payload: count,
  });
};

// Action creator for updating the process count and total image quota that is shown in the Topbar(through Topbar component in Main.js in layouts folder), author:Sai
export const updateProcessCountAndTotalImageProcessAllowance = (payload) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_PROCESS_COUNT_AND_TOTAL_IMAGE_PROCESS_ALLOWANCE",
      payload,
    });
  };
};

export const updateUserSettings = (payload) => {
  return async (dispatch) => {
    const users = await getUsers();
    const currentUserId = users[0]?.user_id;
    const userSettings = await getUserSettingsFromIdb();
    await updateUserSettingsIdb(userSettings?.user_id || currentUserId, {
      ...userSettings[0],
      ...payload,
    });
    return dispatch({
      type: "UPDATE_USER_SETTINGS",
      payload,
    });
  };
};

export const getSignedUrlForOrgLogoAndSignature = () => {
  return async (dispatch) => {
    try {
      const backendRes = await client.post(
        "/s3/signedurl",
        { s3ObjectType: ["logo", "signature"] },
        {
          headers: {
            Accept: "*/*",
            authorization: getAuthTokenFromSessionStorage(),
          },
        }
      );
      const users = await getUsers();
      const currentUserId = users[0]?.user_id;
      const orzLogoUrl = backendRes?.data?.s3UrlArr?.[0]?.url || "";
      const signatureUrl = backendRes?.data?.s3UrlArr?.[1]?.url || "";
      await updateUserDetail(currentUserId, {
        ...users[0],
        orzLogoUrl,
        signatureUrl,
      });

      return dispatch({
        type: "SET_ORG_LOGO_AND_SIGNATURE_SIGNED_URL",
        payload: backendRes?.data?.s3UrlArr,
      });
    } catch (err) {
      console.log("logo and signature fetch error", err);
    }
  };
};

export const getConsultantDataForTheCurrentUserAction = (
  orgzFeaturesAction
) => {
  return async (dispatch) => {
    let payload;
    try {
      const response = await client.get("/consultant-data", {
        headers: {
          Accept: "*/*",
          authorization: getAuthTokenFromSessionStorage(),
        },
      });
      payload = {
        ...response?.data?.consultantDetails,
        msg: response?.data?.msg,
      };

      orgzFeaturesAction(
        response.data.consultantDetails?.isCurrentUserAConsultant
      );

      return dispatch({
        type: "GET_CONSULTANT_DATA",
        payload,
      });
    } catch (error) {
      payload = { ...error?.response?.data, msg: error?.response?.data?.msg };
      orgzFeaturesAction(false);
      return dispatch({
        type: "GET_CONSULTANT_DATA",
        payload,
      });
    }
  };
};
